import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostBinding,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { IAppState } from "../../../store/state/app.state";
import { loadingSelector } from "../../../store/selectors/loading.selector";
import { Subscription } from "rxjs";
import { iconsLibrary } from "../../../../theme/constants";

@Component({
  selector: "cowing-core-loading-window",
  templateUrl: "./cowing-loading-window.component.html",
  styleUrls: ["./cowing-loading-window.component.scss"],
})
export class CowingLoadingWindowComponent {
  @HostBinding("hidden")
  hidden = true;

  loading$ = this._store.pipe(select(loadingSelector));
  subscription: Subscription;
  constructor(private _store: Store<IAppState>) {}

  ngOnInit() {
    this.subscription = this.loading$.subscribe((result) => {
      console.log(result);
      this.hidden = result.hidden;
    });
  }
  public get getLoadingIcon() {
    return `${iconsLibrary.loadingSvg}`;
  }
}
